export default __webpack_public_path__ + "6cec7d5.png";